import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullCheck'
})
export class NullCheckPipe implements PipeTransform {

  transform(value: any): string {
    if (value === null || value === 'null' || value === '') {
      return '';
    }
    return value;
  }
}